export class CroquisSizeConfig{
  width: number;
  height: number;

  constructor(width:number, height:number){
    this.width = width;
    this.height = height;
  }

  public static defaultSize(){
    return new CroquisSizeConfig(750, 400);
  }

  public static customSize(width: number, height: number){
    return new CroquisSizeConfig(width, height);
  }
}
